import Swiper from 'swiper';

export default function newProductSlider (container) {

  const breakpoint = window.matchMedia( '(max-width:799px)' );
    let mySwiper;
    const check = function() {
        if ( breakpoint.matches === true ) {
            if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
            return;
        } else if ( breakpoint.matches === false ) {
            return mySwiper = new Swiper (container, {
              loop: true,
              loopFillGroupWithBlank: true,
              breakpoints: {
                768: {
                  slidesPerView: 4,
                  slidesPerGroup: 4,
                  spaceBetween: 24,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                },
                480: {
                  direction: "horizontal",
                  slidesPerGroup: 1,
                  spaceBetween: 4,
                  effect: 'slide',
                  slidesPerView: 1,
                  mousewheel: {
                      invert: false,
                  },
                }
              },
            });
        }
    };

    breakpoint.addListener(check);
    check();
}